import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[noWhitespace]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: NoWhitespaceDirective,
    multi: true
  }]
})
export class NoWhitespaceDirective implements Validator {

  constructor() {
  }

  validate(control: AbstractControl): ValidationErrors {
    if (!control.value || control.value.trim() === '') {
      return {required: true};
    }
    return null;
  }
}
